import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {
  proRes: any; url; signLoader = false;
  constructor(private alert: ToastrService, private conn: ConnectionService, private route: Router) { }

  ngOnInit() {
    this.conn.changebackground();
    this.url = this.route.url;
    this.getCMS()
  }

  getCMS() {
    var page = this.url.split('/')[1]
    var data = { "pagehint": page };
    this.conn.postUrl('cms/post_cms', data).subscribe((res: any) => {
      this.proRes = res.data;
    })
    this.conn.clearbackground();
  }

  submitFunc(contactusdetails: NgForm) {
    var data = contactusdetails.value;
    this.signLoader = true;
    this.conn.postUrl('users/contactus', data).subscribe((res: any) => {
      if (res.status == 1) {
        this.alert.success(res.msg, 'Success');
      } else if (res.status == 4) {
        this.alert.error(res.msg, 'Error');
      } else {
        this.alert.error(res.msg, 'Error');
      }
      contactusdetails.resetForm();      
      this.signLoader = false;
    });
  }
}